module.exports = __webpack_public_path__ + "img/logoKerala.6a09efc2.png";